import React from 'react';
import { useTranslation } from 'react-i18next';

import { Winning } from '../types/prize.types';

export const usePrizeSteps = (
    isCash: boolean = true,
    identityTaxVerified: boolean,
    offlinePayment: boolean = false,
    winning?: Winning,
    isTaxInterviewCompleted: boolean = false
) => {
    const { t } = useTranslation();
    let step3Title = t('epic.esport.step3.title.v2');
    if (
        Boolean(!isTaxInterviewCompleted && winning?.eventOfflinePaymentMarked) || // If the user has not completed the tax interview, we only consider eventOfflinePaymentMarked as the condition to determine offline
        Boolean(isTaxInterviewCompleted && offlinePayment)
    ) {
        step3Title = t('epic.esport.step3.title.offline.v2');
    }
    if (!isCash) {
        step3Title = t('epic.esport.step3.title.pg.v2');
    }
    return React.useMemo(() => {
        const steps: string[] = [
            identityTaxVerified
                ? t('epic.esport.step1.release.title')
                : t('epic.esport.step1.title'),
            t('epic.esport.step2.title.v2'),
            step3Title
        ];
        return steps;
    }, [offlinePayment, isCash]);
};
